import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RuleManage = _resolveComponent("RuleManage")!
  const _component_SaleCue = _resolveComponent("SaleCue")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_dc_layout_main, { "aside-width": "400px" }, {
      aside: _withCtx(() => [
        _createVNode(_component_RuleManage, {
          listData: _ctx.listData,
          onSelectTag: _ctx.selectTag
        }, null, 8, ["listData", "onSelectTag"])
      ]),
      main: _withCtx(() => [
        _createVNode(_component_SaleCue)
      ]),
      _: 1
    })
  ]))
}